// import React, { useState } from "react";
// import "./HtmlRender.scss";
import Parser from "html-react-parser";

interface IHtmlRenderProps {
  value: string;
  className?: string;
}

/**
 * @description accepts in a string or html string that gets parsed and rendered as html
 * @param value string - string or string of HTML to render
 * @param className string - className you want to apply to the parent of the rendered html string
 * @returns React.Component
 * @example
 * <HtmlRender className="paragraph" value="<div>Something to render</div>/>"
 */
const HtmlRender = (props: IHtmlRenderProps) => {
  // This can't use Typography from Material because that causes nested <p> tags when paired with tinymce
  return (<div className={props.className ?? ""} style={{margin:'5px'}}>{Parser(props.value)}</div>);
};

export default HtmlRender;